import { getDatapointLabelForDatapointId } from "hooks/widget-data/use-datapoints";
export const tryToAddCustomDatapointsAsGroups = (userSelectedGroups, measures, excelOptions) => {
    if (userSelectedGroups && userSelectedGroups.length > 0) {
        userSelectedGroups.forEach((userSelectedGroup) => {
            const customDatapointGroup = measures.find((x) => x.name === userSelectedGroup);
            if (customDatapointGroup) {
                if (!excelOptions.some((x) => x.datapointKeyName === userSelectedGroup)) {
                    excelOptions.push({
                        datapointKeyName: userSelectedGroup,
                        datapointLabelName: customDatapointGroup.datapoint.custom
                    });
                }
            }
        });
    }
};
const tryAddLabelTranslation = (group, matchingGroups, measures) => {
    if (matchingGroups.length !== 1 || !matchingGroups[0]) {
        return null;
    }
    const labelDatapoint = getDatapointLabelForDatapointId(matchingGroups[0].toString());
    if (!labelDatapoint) {
        return null;
    }
    const labelDatapointNames = measures.filter((d) => d.datapoint?.standard?.toString() === labelDatapoint);
    if (labelDatapointNames.length >= 1 && labelDatapointNames[0]?.name) {
        return {
            datapointKeyName: group,
            datapointLabelName: labelDatapointNames[0].name
        };
    }
    return null;
};
export const createDatapointTotalGroupExcelOptions = (userSelectedGroups, measures, dimensions) => {
    const retainedDimensions = (dimensions || []).map((d) => d.name || "").filter((d) => userSelectedGroups.includes(d));
    const ret = [];
    for (const group of retainedDimensions) {
        const matchingGroups = dimensions.filter((d) => d.name === group && d.datapoint?.standard).map((d) => d.datapoint.standard);
        const translation = tryAddLabelTranslation(group, matchingGroups, measures);
        if (translation && !ret.some((g) => g.datapointKeyName === group)) {
            ret.push(translation);
        }
        else {
            ret.push({ datapointKeyName: group });
        }
    }
    return ret;
};
